import { useEffect } from 'react';
import { Header } from '@/components/home/Header';
import { Hero } from '@/components/home/Hero';
import { Organizations } from '@/components/home/Organizations';
import { Showcase } from '@/components/home/Showcase';
import { Modes } from '@/components/home/Modes';
import { Faq } from '@/components/home/Faq';
import { FinalCta } from '@/components/home/FinalCta';
import { Footer } from '@/components/home/Footer';
import { MarketingHead } from '@/components/home/MarketingHead';

export default function Home() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);

  return (
    <>
      <MarketingHead />
      <Header />
      <main className="min-h-screen bg-bg-primary text-fg-primary">
        <Hero />
        <Organizations />
        <Showcase />
        <Modes />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </>
  );
}
